import React, { useState } from 'react';
import IntlMessages from '@projectK/helpers/IntlMessages';
import * as yup from 'yup';
import { useInfoViewActionsContext } from '@projectK/context/InfoViewContextProvider';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import { useToast } from '@projectK/context/ToastProvider';
import { SeparateParentMemberMain } from '@projectK/MainComponents';
import PropTypes from 'prop-types';
const validationSchema = yup.object({
  first_name: yup
    .string()
    .matches(/^\S(?:.*\S)?$/, () => <IntlMessages id='validation.firstName.noSpaces' />)
    .required(<IntlMessages id='validation.firstNameRequired' />),
  last_name: yup
    .string()
    .matches(/^\S(?:.*\S)?$/, () => <IntlMessages id='validation.lastName.noSpaces' />)
    .required(<IntlMessages id='validation.lastNameRequired' />),
  email: yup
    .string()
    .matches(
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
      () => <IntlMessages id='validation.invalidEmailFormat' />
    )
    .typeError(<IntlMessages id='validation.invalidEmail' />)
    .required(<IntlMessages id='validation.emailRequired' />),
  password: yup
    .string()
    .required(<IntlMessages id='validation.passwordRequired' />)
    .min(8, () => <IntlMessages id='validation.passwordTooShort' />)
    .matches(
      /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}[\]:;<>,.?~\\/-])/,
      () => <IntlMessages id='validation.passwordWeak' />
    ),
  confirmPassword: yup
    .string()
    .required(<IntlMessages id='validation.repeatPasswordRequired' />)
    .oneOf([yup.ref('password'), null], () => <IntlMessages id='validation.passwordsDoNotMatch' />),
});

const existingValidationSchema = yup.object({
  first_name: yup
    .string()
    .matches(/^\S(?:.*\S)?$/, () => <IntlMessages id='validation.firstName.noSpaces' />)
    .required(<IntlMessages id='validation.firstNameRequired' />),
  last_name: yup
    .string()
    .matches(/^\S(?:.*\S)?$/, () => <IntlMessages id='validation.lastName.noSpaces' />)
    .required(<IntlMessages id='validation.lastNameRequired' />),
  email: yup
    .string()
    .matches(
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
      () => <IntlMessages id='validation.invalidEmailFormat' />
    )
    .typeError(<IntlMessages id='validation.invalidEmail' />)
    .required(<IntlMessages id='validation.emailRequired' />),
  password: yup
    .string()
    .required(<IntlMessages id='validation.passwordRequired' />)
    .min(8, () => <IntlMessages id='validation.passwordTooShort' />)
    .matches(
      /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}[\]:;<>,.?~\\/-])/,
      () => <IntlMessages id='validation.passwordWeak' />
    ),
  confirmPassword: yup
    .string()
    .required(<IntlMessages id='validation.repeatPasswordRequired' />)
    .oneOf([yup.ref('password'), null], () => <IntlMessages id='validation.passwordsDoNotMatch' />),
});

const customScrollbarStyle = {
  // Define the styles for the scrollbar
  '&::-webkit-scrollbar': {
    width: '8px',
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#44444461', // Lighter black color
    borderRadius: '8px', // Curved border
  },

  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#666', // Lighter black color on hover
  },
};

const SeperateParentMembers = ({ isOpen, onClose, fetchMembersData, data }) => {
  const companyTheme = CompanyTheme();
  const { mobileMode } = useMobileSettings();
  const showToast = useToast();
  const infoViewActionsContext = useInfoViewActionsContext();
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showRetypeNewPassword, setShowRetypeNewPassword] =
    React.useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const { user } = useAuthUser();

  const onShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };

  const onDownNewPassword = (event) => {
    event.preventDefault();
  };

  const onShowRetypeNewPassword = () => {
    setShowRetypeNewPassword(!showRetypeNewPassword);
  };

  const onDownRetypeNewPassword = (event) => {
    event.preventDefault();
  };

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleCloseModalDialog = () => {
    setOpenDialog(false); // to close the dialog
    handleModalClose(); //to close the modal
  };
  const handleModalClose = () => {
    onClose();
  };
  return (
    <SeparateParentMemberMain
      isOpen={isOpen}
      handleDialogOpen={handleDialogOpen}
      fetchMembersData={fetchMembersData}
      customScrollbarStyle={customScrollbarStyle}
      data={data}
      user={user}
      validationSchema={validationSchema}
      existingValidationSchema={existingValidationSchema}
      companyTheme={companyTheme}
      onShowNewPassword={onShowNewPassword}
      onDownNewPassword={onDownNewPassword}
      showNewPassword={showNewPassword}
      showRetypeNewPassword={showRetypeNewPassword}
      onShowRetypeNewPassword={onShowRetypeNewPassword}
      onDownRetypeNewPassword={onDownRetypeNewPassword}
      openDialog={openDialog}
      handleCloseDialog={handleCloseDialog}
      handleCloseModalDialog={handleCloseModalDialog}
      infoViewActionsContext={infoViewActionsContext}
      showToast={showToast}
      mobileMode={mobileMode}
      onClose={onClose}
      setShowNewPassword={setShowNewPassword}
      setShowRetypeNewPassword={setShowRetypeNewPassword}
    />
  );
};

export default SeperateParentMembers;
SeperateParentMembers.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  fetchMembersData: PropTypes.func,
  data: PropTypes.object,
};
